import React from 'react';

export default function BenchmarkingCard({ metrics }) {
  const { yourVisitors, avgVisitors, medianVisitors, percentile, totalListings } = metrics || {};

  // Determine the comparison status
  const aboveAverage = yourVisitors > avgVisitors;
  const percentileText = percentile >= 75 ? 'Top 25%' :
    percentile >= 50 ? 'Top 50%' :
    percentile >= 25 ? 'Bottom 50%' : 'Bottom 25%';
  const percentileColor = percentile >= 75 ? 'text-green-600' :
    percentile >= 50 ? 'text-blue-600' :
    percentile >= 25 ? 'text-yellow-600' : 'text-red-600';

  return (
    <div className="bg-white rounded-lg shadow p-6">
      <h3 className="text-sm font-medium text-gray-500 mb-4">Benchmarking</h3>

      <div className="space-y-4">
        {/* Main comparison */}
        <div className="flex items-baseline gap-2">
          <span className="text-3xl font-bold text-gray-900">{yourVisitors}</span>
          <span className="text-sm text-gray-500">your visitors</span>
        </div>

        {/* Comparison to average */}
        <div className="flex items-center gap-2">
          {aboveAverage ? (
            <svg className="w-5 h-5 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 10l7-7m0 0l7 7m-7-7v18" />
            </svg>
          ) : (
            <svg className="w-5 h-5 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
            </svg>
          )}
          <span className={aboveAverage ? 'text-green-600 font-medium' : 'text-red-600 font-medium'}>
            {aboveAverage ? 'Above' : 'Below'} average
          </span>
        </div>

        {/* Stats grid */}
        <div className="grid grid-cols-3 gap-4 pt-4 border-t border-gray-200">
          <div>
            <p className="text-lg font-semibold text-gray-900">{avgVisitors}</p>
            <p className="text-xs text-gray-500">Average</p>
          </div>
          <div>
            <p className="text-lg font-semibold text-gray-900">{medianVisitors}</p>
            <p className="text-xs text-gray-500">Median</p>
          </div>
          <div>
            <p className={`text-lg font-semibold ${percentileColor}`}>{percentileText}</p>
            <p className="text-xs text-gray-500">Your rank</p>
          </div>
        </div>

        <p className="text-xs text-gray-400 pt-2">
          Compared to {totalListings} listings in this passport
        </p>
      </div>
    </div>
  );
}
